// extracted by mini-css-extract-plugin
module.exports = {"modal__wrapper":"styles_modal__wrapper___uZax","clickEffect":"styles_clickEffect__zYkhb","pulse":"styles_pulse__sM9jR"};